import React, { useState, useEffect } from 'react';
// import { logout } from '../api/auth';
import {getAuthenticatedUser} from '../api/auth.sso';
import images from '../images';
// import useAuth from '../hooks/useAuth';
import LogoBlock from '../components/LogoBlock';
import {Link, useLocation} from "react-router-dom";
import { useNotifications } from '../context/NotificationsContext';

const Header = () => {
  // const { logout: contextLogout } = useAuth();
  const location = useLocation();
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { openNotifications } = useNotifications();
  
  const getActivePage = (pathname) => {
    if (pathname.includes('/my-leads')) return '/my-leads';
    if (pathname.includes('/profile')) return '/profile';
    return '/my-flows';
  };

  
  const activePage = getActivePage(location.pathname);

  // const handleLogout = async () => {
  //   try {
  //     await logout();
  //     contextLogout();
  //   } catch (error) {
  //     console.error('Ошибка при выходе:', error);
  //   }
  // };
  
  const handleTelegramClick = () => {
    console.log('handleTelegramClick', userData.tg_utl);
    if (userData?.tg_utl) {
      window.open(userData.tg_utl, '_blank', 'noopener,noreferrer');
    }
  };

  const handleOpenNotificationsModal = () => {
    openNotifications(userData.id);
  };

  const handleRulesClick = () => {
    console.log('handleRulesClick');
    window.open('https://docs.google.com/document/d/1tarscKtoRJdB8ZndtuVDLQdgfOq8Qz4hEboO46dv_ng/edit?tab=t.0', '_blank', 'noopener,noreferrer');
  };
  useEffect(() => {
    let isMounted = true;

    const loadUserData = async () => {
      try {
        setLoading(true);
        setError(null);

        // 1. Получаем данные пользователя
        const userData = await getAuthenticatedUser();
        console.log("userData: ", userData);
        // Проверяем, что компонент все еще смонтирован перед обновлением состояния
        if (!isMounted) return;

        setUserData(userData);

      } catch (error) {
        // Проверяем, что компонент все еще смонтирован перед обновлением состояния
        if (isMounted) {
          console.error('Ошибка при загрузке данных профиля:', error);
          setError(error.message || 'Не удалось загрузить данные профиля');
        }
      } finally {
        // Проверяем, что компонент все еще смонтирован перед обновлением состояния
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadUserData();

    // Очистка при размонтировании компонента
    return () => {
      isMounted = false;
    };
  }, []);


  return (
    <header className="header">
      <div className="header-container">
        <LogoBlock />
        
        <nav className="navigation">
          <ul>
            <li>
              <Link
                  to="/my-flows"
                  className={activePage === '/my-flows' ? 'active' : ''}
              >

                <img 
                  src={activePage === '/my-flows' ? images.dashboardActive : images.dashboard}
                  alt="" 
                  className="nav-icon" 
                />
                Мои потоки
              </Link>
            </li>
            <li>
              <Link
                  to="/my-leads"
                  className={activePage === '/my-leads' ? 'active' : ''}
              >
                <img 
                  src={activePage === '/my-leads' ? images.peopleActive : images.people}
                  alt="" 
                  className="nav-icon" 
                />
                Мои идентификации
              </Link>
            </li>
            <li>
              <Link
                  to="/profile"
                  className={activePage === '/profile' ? 'active' : ''}
              >
                <img 
                  src={activePage === '/profile' ? images.userActive : images.user}
                  alt="" 
                  className="nav-icon" 
                />
                Профиль
              </Link>
            </li>
          </ul>
        </nav>
        
        <div className="header-footer">
          {userData?.tg_utl && (
            <button 
              className="footer-button"
              onMouseDown={handleTelegramClick}
            >
              <img src={images.telegram} alt="" className="footer-icon" />
              <span className="footer-text telegram">Перейти в чат</span>
            </button>
          )}
          <button className="footer-button" onClick={() => handleOpenNotificationsModal()}>
            <img src={images.bellBold} alt="" className="footer-icon"/>
            <span className="footer-text telegram">Уведомления</span>
          </button>
          <button
              className="footer-button"
              onMouseDown={handleRulesClick}
          >
            <img src={images.question} alt="" className="footer-icon" />
            <span className="footer-text rules">Правила пользования</span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
